import { App, Plugin, watch } from 'vue';
import { useAppNotificationStore } from '@lib/stores/app-notifications';

import type { User } from '@lib/types';

/*export interface NotificationOptions {
    url: string;
}*/

const NotificationPlugin: Plugin = {
	install: (app: App) => {
		// We are not in a vue instance yet, injection based useComposables do not work, pinja stores do
		const auth = app.config.globalProperties.$auth;

		// Watch for the user logged in
		watch(
			() => auth.user(),
			(user: User) => {
				if (user) {
					const notificationStore = useAppNotificationStore();
					notificationStore.enable();
					notificationStore.sync();
				}
			},
		);
	},
};

export default NotificationPlugin;
